// the Spanish home used to be ?lang=es: it is /es/ now
import { $, LANG, SB, avatar, creditsHtml, duo, esc, icon, inRoom, myCharacter, pageHref, t, track, typeDesc, typeTitle, vinylSvg } from '../web/common.ts';
import { dayGo, dayNo, keptLegend, savedMeta, streakOf, today, untilTomorrow } from '../web/daily.ts';
import type { LegendWords } from '../web/daily.ts';
import type { DailyGo } from '../core/solo-core.ts';
import { SBACCT } from '../web/account.ts';
import { pinOn } from '../web/pin.ts';
import { mountNav } from '../web/nav.ts';
import { keepFriendCount } from '../web/nav-friends.ts';
import { guestOutfit, progressOf } from '../core/wardrobe.ts';
import { presenter } from '../web/presenter.ts';
import type { PoseName } from '../web/presenter.ts';
import type { Outfit } from '../core/wardrobe.ts';
import type { RoundType, Species } from '../core/types.ts';
import type { IconName, Mood } from '../web/common.ts';
if (location.pathname === '/' && new URLSearchParams(location.search).get('lang') === 'es') location.replace('/es/');
document.querySelectorAll<HTMLElement>('[data-t]').forEach((el) => { el.textContent = t(el.dataset.t!); });
$('#headline').innerHTML = t('Name that <em>tune</em>');
mountNav('home'); keepFriendCount();
$('#rec').innerHTML = vinylSvg('#ff6a3d');
// Rafa dances on the record, a new dance every two bars, in on the beat with a hop (still, where motion is turned down)
const rafa = $('#rafa'), DANCES: PoseName[] = ['dance', 'floss', 'roof', 'twist', 'robot', 'flamenco', 'croon'];
rafa.innerHTML = presenter.svg('rafa', DANCES[0]);
if (!matchMedia('(prefers-reduced-motion: reduce)').matches) {
  let n = 0;
  setInterval(() => {
    presenter.pose(rafa.firstElementChild as SVGSVGElement, DANCES[++n % DANCES.length]);
    rafa.classList.remove('hop'); void rafa.offsetWidth; rafa.classList.add('hop');
  }, 3840);
}
// The cast in a row before the rules, each in something from the wardrobe. Signed in, the first one is you.
type Rider = [species: Species, color: string, mood: Mood, outfit: Outfit];
const RIDERS: Rider[] = [['frog', '#c6f432', 'grin', { hat: 'wizard', extra: 'cape' }], ['bunny', '#ff5fa2', 'smile', { hat: 'tophat', eyes: 'shades' }], ['robot', '#38bdf8', 'smile', { hat: 'viking', skin: 'gold' }], ['ghost', '#ffe14d', 'grin', { hat: 'sombrero', eyes: 'stars' }]];
$('#crowd').innerHTML = RIDERS.map(([species, color, mood, outfit], i) => `<div class="who">${avatar({ pid: 'home' + i, species, color, outfit }, mood)}</div>`).join('');
$('#credits').innerHTML = creditsHtml();
// the banner that puts SongBuzz on the home screen: shown or not before the first paint (index.html), its taps in pin.ts
document.querySelector('.pinbar .x')!.setAttribute('aria-label', t('Close'));
if (!pinOn()) delete document.documentElement.dataset.pin;
else if (document.documentElement.dataset.pin) track('pin_shown', { where: 'home' });
// Your character's way in
$<HTMLAnchorElement>('#looksLink').href = pageHref('/look');
function paintLook() {
  const mine = SBACCT && SBACCT.acct ? SBACCT.outfit() : null, [species, color, mood, outfit] = RIDERS[0];
  // signed out (where you could sign in) you're clay and plain: colour comes with an account
  const clay = !mine && !!SBACCT && SBACCT.googleOn();
  $('#lookAv').innerHTML = avatar({ ...myCharacter(mine || (SBACCT ? guestOutfit(SBACCT.tryOn) : {})), clay }, 'grin');
  $('#lookWords').textContent = mine ? t('Your look') : t('Dress your character');
  $('#crowd .who').innerHTML = mine ? avatar(myCharacter(mine), 'grin') : avatar({ pid: 'home0', species, color, outfit }, mood);
}
paintLook();
if (SBACCT) SBACCT.onChange(paintLook);
document.querySelectorAll<HTMLElement>('.ic-slot').forEach((el) => { el.outerHTML = icon(el.dataset.icon as IconName); });
// Today's Daily on its card, from Solo's progress on this device. Never played here, it says what the Daily is; played
// before but not today, today's Legend is the reason to tap; played today, a tick, your score and when the next opens.
// A streak of two days or more rides on the sticker.
$('#dailyTitle').textContent = t('Daily Gig #{n}', { n: dayNo() });
(() => {
  const M = savedMeta(), D = M && M.daily;
  if (!M || !D || !Object.keys(D.days).length) return;
  const streak = streakOf(D, M.uid), go = dayGo(D, today(), M.uid), line = $('#dailyLine');
  if (streak > 1) $('#dailyBtn').insertAdjacentHTML('afterbegin', `<span class="tag">${duo('fire')}${esc(t('{n}-day streak', { n: streak }))}</span>`);
  if (go) { $('#dailyTitle').insertAdjacentHTML('beforeend', duo('check-fat')); line.textContent = playedLine(go); $('.launch').classList.add('done'); return; } // (played: the party leads)
  const show = (w: LegendWords | null | undefined) => {
    if (!w) return;
    line.classList.add('legend');
    // a small label with the crown, the Legend's name under it, its twist last
    line.innerHTML = `<span class="lgk">${duo('crown')}${esc(t('Today’s Legend'))}</span><b class="lgn">${esc(w.name)}</b>${esc(w.desc)}`;
  };
  // kept by Solo for the week ahead; if not, Solo's rules come in to deal it (and keep the week)
  const kept = keptLegend(today(), LANG);
  if (kept) show(kept);
  else import('../web/daily-legend.ts').then((m) => show(m.keepWeek()[today()])).catch(() => {});
})();
// The Tour on the same card: where you are in it, once you've played it here
(() => {
  const M = savedMeta();
  if (!M || !(+M.runs! > 0)) return;
  const fans = (+M.fans! || 0).toLocaleString(LANG === 'es' ? 'es-ES' : 'en-US');
  $('#tourLine').textContent = t('The Tour: level {n}, {fans} fans', { n: progressOf(M).level, fans });
})();
function playedLine(go: DailyGo) {
  const s = go.standing, p = s && s.n && s.n > 1 ? Math.round((100 * (s.below || 0)) / (s.n - 1)) : 0;
  const v = { pts: Math.round(go.hype).toLocaleString(LANG === 'es' ? 'es-ES' : 'en-US'), p, time: untilTomorrow() };
  if (p >= 100) return t('Today: {pts} points, the best score so far. The next one opens in {time}.', v);
  return p > 0 ? t('Today: {pts} points, better than {p}% of players. The next one opens in {time}.', v) : t('Today: {pts} points. The next one opens in {time}.', v);
}
// A party this device was in a few minutes ago and didn't leave on purpose (a closed tab, a phone that died): the
// way back leads. A player's seat and points wait for them; a phone that ran the game opens it again in the same room.
(() => {
  const r = SB.mode === 'cloud' ? inRoom() : null;
  if (!r) return;
  const a = document.createElement('a');
  a.className = 'cta backin'; a.href = r.host ? '/play/new' : '/j?r=' + r.r; a.dataset.choice = 'back';
  a.innerHTML = `${icon('buzzer')}<span><b>${esc(r.host ? t('Back to your party') : t('Back to the game'))}</b><small>${esc(r.host ? t('Room {code} is waiting for you.', { code: r.r }) : t('You were playing in room {code}.', { code: r.r }))}</small></span>`;
  $('.launch').prepend(a);
})();
// a party on this device needs cloud rooms: on the LAN this server is the show, so the party starts on this screen
if (SB.mode !== 'cloud') { const h = $<HTMLAnchorElement>('#hostBtn'); h.href = '/tv'; h.querySelector('small')!.textContent = t('On a TV or a computer: this screen plays the songs, everyone answers on their phone.'); }
for (const id of ['#tourLink', '#tvLink']) $<HTMLAnchorElement>(id).href = pageHref(id === '#tvLink' ? '/party' : '/solo');
document.querySelectorAll<HTMLElement>('[data-choice]').forEach((a) => a.addEventListener('click', () => track('home_choice', { choice: a.dataset.choice })));

// The rounds, each on its own colour, the same as its field on the TV.
const ROUNDS: [id: RoundType, color: string, pts: string][] = [['fastest', '#ff6a3d', '3 · 2 · 1'], ['buzzer', '#12b8a6', '2'], ['year', '#ff5f9e', '5'], ['snippet', '#3fb6ff', '5'], ['twisted', '#2ee6a6', '3'], ['timeline', '#ffc531', '3'], ['lyrics', '#c6f432', '3 · 2 · 1'], ['hum', '#8b6cff', '3 · 2 · 1'], ['medley', '#141432', '18']];
$('#rgrid').innerHTML = ROUNDS.map(([id, c, pts]) => `<div class="rcard ${id === 'medley' ? 'dark' : ''}" style="--rc:${c}"><h3>${esc(typeTitle(id))}</h3><p>${esc(typeDesc(id))}</p></div>`).join('');

const codeIn = $<HTMLInputElement>('#code');
codeIn.addEventListener('input', () => { codeIn.value = codeIn.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 4); });
$('#codeForm').onsubmit = (e) => {
  e.preventDefault();
  const v = codeIn.value.toUpperCase().replace(/[^A-Z]/g, '');
  if (SB.mode === 'cloud' && v.length !== 4) return codeIn.focus();
  track('home_choice', { choice: 'join' });
  location.href = '/j' + (v ? '?r=' + v : '');
};
if (SB.mode !== 'cloud') { $('#codeLabel').textContent = t('On the same Wi-Fi as the game?'); codeIn.style.display = 'none'; $('#joinHint').textContent = t("Or scan the QR code on the game's screen."); }
